/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  const lemonadePlanId = '698021839131';

  function filterSkioCartPlans() {
    document
      .querySelectorAll('#slidecarthq .subscription-option select')
      .forEach(function(select) {

        const cartItem =
          select.closest('.item') ||
          select.closest('[data-item]') ||
          select.closest('.cart-item') ||
          select.parentElement.parentElement.parentElement;

        if (!cartItem) return;

        const itemText = cartItem.innerText.toLowerCase();
        const isLemonade = itemText.includes('lemonade');

        Array.from(select.options).forEach(function(option) {
          const isOneTime = option.value === '';
          const isLemonade20 = option.value === lemonadePlanId;

          if (isLemonade) {
            // Lemonade: only One-time + 20% plan
            if (!isOneTime && !isLemonade20) {
              option.remove();
            }
          } else {
            // All other flavors: remove Lemonade 20% plan
            if (isLemonade20) {
              option.remove();
            }
          }
        });

      });
  }

  function runFilter() {
    setTimeout(filterSkioCartPlans, 100);
    setTimeout(filterSkioCartPlans, 500);
    setTimeout(filterSkioCartPlans, 1000);
  }

  document.addEventListener('DOMContentLoaded', runFilter);
  document.addEventListener('theme:cart:change', runFilter);
  document.addEventListener('theme:cart:init', runFilter);

  const observer = new MutationObserver(function() {
    filterSkioCartPlans();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();